<div class="sh-filter-bar">
  @for (filter of filters$ | async; track filter) {
    <sh-generic-filter-item
      [filter]="filter"
      [i18n]="i18n"
      (filterChanged)="onFilterChange($event)"
      (removeFilter)="onRemoveFilter(filter)"
    ></sh-generic-filter-item>
  }
</div>
